import { Box, Button } from '@ouster/webviz-react-components';

import { Link } from 'react-router-dom';

export function PublicDownloadWarning() {
  return (
    <Box
      display="grid"
      maxW={640}
      rowGap={6}
      data-testid="public-upload-warning"
    >
      <Box lineHeight={1.8}>
        Access to our rich library of sample lidar datasets is exclusively for
        registered Ouster Studio users.
      </Box>
      <Box lineHeight={1.8} mb={6}>
        Sign up for free today to instantly download high-quality sample data,
        explore various environments, and kickstart your projects with
        real-world lidar examples. Accelerate your development and unleash the
        full potential of Ouster Studio!
      </Box>
      <Link
        to="/sign_up"
        style={{ textDecoration: 'none', justifySelf: 'end' }}
      >
        <Button size="lg" minWidth={150} mt={4} data-testid="public-signup-btn">
          Sign up for free
        </Button>
      </Link>
    </Box>
  );
}
